import { useTranslations } from "next-intl";

import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

interface IPieceNumberProps extends React.ComponentProps<"input"> {
    isPending: boolean;
}

export const PieceNumber = ({ isPending, ...props }: IPieceNumberProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("pieceNumber")} :</FormLabel>
            <FormControl className="w-full md:w-1/2">
                <Input { ...props } disabled={ isPending } />
            </FormControl>
            <FormMessage />
        </FormItem>
    );
};